export const LEGACY_QR_WAITER_CONTACT_DETAILS_KEY = "user";
export class LegacyQrWaiterContactDetailsStorageManager {
    store(_) {
        throw new Error("Method not implemented.");
    }
    restore() {
        const legacyContactDetailsDataString = localStorage.getItem(LEGACY_QR_WAITER_CONTACT_DETAILS_KEY);
        if (legacyContactDetailsDataString === null) {
            return null;
        }
        const legacyContactDetailsData = JSON.parse(legacyContactDetailsDataString);
        try {
            return {
                type: "QRWaiter",
                email: legacyContactDetailsData.email,
            };
        }
        catch (_) {
            return null;
        }
    }
    erase() {
        throw new Error("Method not implemented.");
    }
}
